import { includes } from 'lodash';

import NOTICIA_SEARCH from '@/graphql/queries/NoticiaSearch.gql';
import NOTICIA_SEARCH_ES from '@/graphql/queries/NoticiaSearchES.gql';
import CATEGORIAS from '@/graphql/revista/queries/Categorias.gql';
import { errorGQLHandler, anyDateFormat } from '@/helpers/helpers';
import env from '@/config/env';
import { getUF } from '@/utils/ufs';

const RESET_BUSCA = 'RESET_BUSCA';
const SET_PALAVRA_CHAVE = 'SET_BUSCA_PALAVRA_CHAVE';
const SET_TAGS = 'SET_BUSCA_TAGS';
const SET_PERIODO_DE_PUBLICACAO = 'SET_BUSCA_PERIODO_DE_PUBLICACAO';
const SET_SE_LIGA = 'SET_BUSCA_SE_LIGA';
const SET_INFORME_COMERCIAL = 'SET_BUSCA_INFORME_COMERCIAL';
const SET_VIGENCIA = 'SET_BUSCA_INFORME_COMERCIAL_VIGENCIA';
const SET_PRAZO_DE_LEITURA = 'SET_BUSCA_INFORME_COMERCIAL_PRAZO_DE_LEITURA';
const SET_CONFIRMADO_AUTOMATICO = 'SET_BUSCA_INFORME_COMERCIAL_CONFIRMADO_AUTOMATICO';
const SET_CONFIRMADO_MANUAL = 'SET_BUSCA_INFORME_COMERCIAL_CONFIRMADO_MANUAL';
const SET_NOTICIAS = 'SET_NOTICIAS';
const SET_LEITURA_PENDENTE = 'SET_BUSCA_INFORME_COMERCIAL_LEITURA_PENDENTE';
const SET_FINDING = 'SET_FINDING';
const SET_NOT_FOUND = 'SET_NOT_FOUND';
const SET_LETURA = 'SET_LETURA';
const SET_TAGS_NOME = 'SET_TAGS_NOME';
const SET_CATEGORIA = 'SET_CATEGORIA';
const SET_UF = 'SET_UF';
const SET_REGIONAL = 'SET_REGIONAL';
const SET_CONFIRMACAO_LEITURA = 'SET_CONFIRMACAO_LEITURA';

export default {
  namespaced: true,
  state: {
    noticias: [],
    palavraChave: '',
    tags: [],
    tagsNome: [],
    periodoDePublicacao: null,
    seLiga: false,
    informeComercial: false,
    vigencia: null,
    prazoDeLeitura: null,
    confirmacaoLeitura: null,
    leituraPendente: false,
    confirmadoAutomatico: false,
    confirmadoManual: false,
    finding: false,
    itemNotFound: false,
    leitura: false,
    categoriaId: [],
    uf: [],
    regional: [],
  },
  getters: {
    palavraChave: state => state.palavraChave,
    tags: state => state.tags,
    tagsNome: state => state.tagsNome,
    periodoDePublicacao: state => state.periodoDePublicacao,
    seLiga: state => state.seLiga,
    informeComercial: state => state.informeComercial,
    vigencia: state => state.vigencia,
    prazoDeLeitura: state => state.prazoDeLeitura,
    leituraPendente: state => state.leituraPendente,
    confirmadoAutomatico: state => state.confirmadoAutomatico,
    confirmadoManual: state => state.confirmadoManual,
    noticias: state => state.noticias,
    finding: state => state.finding,
    itemNotFound: state => state.itemNotFound,
    leitura: state => state.leitura,
    categoriaId: state => state.categoriaId,
    uf: state => state.uf,
    regional: state => state.regional,
  },
  mutations: {
    [RESET_BUSCA](state) {
      state.palavraChave = '';
      state.tags = [];
      state.tagsNome = [];
      state.periodoDePublicacao = null;
      state.seLiga = false;
      state.informeComercial = false;
      state.vigencia = null;
      state.prazoDeLeitura = null;
      state.leituraPendente = false;
      state.confirmadoAutomatico = false;
      state.confirmadoManual = false;
      state.leitura = false;
      state.categoriaId = [];
      state.uf = [];
      state.regional = [];
    },
    [SET_FINDING](state, payload) {
      state.finding = payload;
    },
    [SET_NOT_FOUND](state, payload) {
      state.itemNotFound = payload;
    },
    [SET_PALAVRA_CHAVE](state, payload) {
      state.palavraChave = payload;
    },
    [SET_TAGS](state, payload) {
      state.tags = payload;
    },
    [SET_REGIONAL](state, payload) {
      state.regional = payload;
    },
    [SET_TAGS_NOME](state, payload) {
      state.tagsNome = payload;
    },
    [SET_PERIODO_DE_PUBLICACAO](state, payload) {
      state.periodoDePublicacao = payload;
    },
    [SET_SE_LIGA](state, payload) {
      state.seLiga = payload;
    },
    [SET_INFORME_COMERCIAL](state, payload) {
      state.informeComercial = payload;
    },
    [SET_VIGENCIA](state, payload) {
      state.vigencia = payload;
    },
    [SET_PRAZO_DE_LEITURA](state, payload) {
      state.prazoDeLeitura = payload;
    },
    [SET_CONFIRMACAO_LEITURA](state, payload) {
      state.confirmacaoLeitura = payload;
    },
    [SET_LEITURA_PENDENTE](state, payload) {
      state.leituraPendente = payload;
    },
    [SET_CONFIRMADO_AUTOMATICO](state, payload) {
      state.confirmadoAutomatico = payload;
    },
    [SET_CONFIRMADO_MANUAL](state, payload) {
      state.confirmadoManual = payload;
    },
    [SET_LETURA](state, payload) {
      state.leitura = payload;
    },
    [SET_NOTICIAS](state, payload) {
      state.noticias = payload;
    },
    [SET_CATEGORIA](state, payload) {
      state.categoriaId = payload;
    },
    [SET_UF](state, payload) {
      state.uf = payload;
    },
  },
  actions: {
    resetBusca({ commit }) {
      commit(RESET_BUSCA);
      commit(SET_NOTICIAS, []);
    },
    changePalavraChave({ commit }, value) {
      commit(SET_PALAVRA_CHAVE, value);
    },
    changeTags({ commit }, tags) {
      commit(SET_TAGS, tags);
    },
    changeUf({ commit }, uf) {
      commit(SET_UF, uf);
    },
    changeCategoria({ commit }, categoriaId) {
      commit(SET_CATEGORIA, categoriaId);
    },
    changeTagsNome({ commit }, tags) {
      commit(SET_TAGS_NOME, tags);
    },
    changeSeLiga({ commit }, seLiga) {
      commit(SET_SE_LIGA, seLiga);
    },
    changeRegional({ commit }, regional) {
      commit(SET_REGIONAL, regional);
    },
    changePeriodoDePublicacao({ commit }, data) {
      commit(SET_PERIODO_DE_PUBLICACAO, data);
    },
    changeInformeComercial({ commit }, informeComercial) {
      commit(SET_INFORME_COMERCIAL, informeComercial);
    },
    changeVigencia({ commit }, data) {
      commit(SET_VIGENCIA, data);
    },
    changePrazoDeLeitura({ commit }, data) {
      commit(SET_PRAZO_DE_LEITURA, data);
    },
    changeLeitura({ commit }, leitura) {
      commit(SET_LEITURA_PENDENTE, false);
      commit(SET_CONFIRMADO_AUTOMATICO, false);
      commit(SET_CONFIRMADO_MANUAL, false);
      commit(SET_LETURA, true);
      switch (leitura) {
        case 'Pendente':
          commit(SET_LEITURA_PENDENTE, true);
          commit(SET_CONFIRMACAO_LEITURA, 'pendente');
          break;
        case 'ConfirmadoAutomtico':
          commit(SET_CONFIRMADO_AUTOMATICO, true);
          commit(SET_CONFIRMACAO_LEITURA, 'automatico');
          break;
        case 'ConfirmadoManual':
          commit(SET_CONFIRMADO_MANUAL, true);
          commit(SET_CONFIRMACAO_LEITURA, 'manual');
          break;
      }
    },
    async fetchNoticias({ commit, dispatch }) {
      try {
        commit(SET_NOTICIAS, []);
        commit(SET_FINDING, true);
        commit(SET_NOT_FOUND, false);

        const variables = await dispatch('makeVariables');
        let query = await env.apolloRevista.query({
          query: NOTICIA_SEARCH,
          variables,
          fetchPolicy: 'no-cache',
        });

        const { noticias } = query.data;

        let noticiasArray = [];
        if (Array.isArray(noticias)) {
          noticiasArray = noticias;
        } else if (noticias && Array.isArray(noticias.data)) {
          noticiasArray = noticias.data;
        } else if (noticias && noticias.data) {
          noticiasArray = [noticias.data];
        } else if (noticias) {
          noticiasArray = [noticias];
        }

        if (noticiasArray.length === 0) {
          commit(SET_NOT_FOUND, true);
        } else {
          noticiasArray = noticiasArray.map(noticia => {
            noticia.categoria = noticia.categoriaSlug.categoria;
            noticia.categoriaSlug = noticia.categoriaSlug.slug;
            return noticia;
          });
        }
        commit(SET_NOTICIAS, noticiasArray);
      } catch (e) {
        console.error(e);
        errorGQLHandler(e);
      } finally {
        commit(SET_FINDING, false);
      }
    },
    async fetchNoticiasES({ state, commit, dispatch, rootGetters }) {
      try {
        commit(SET_NOTICIAS, []);
        commit(SET_FINDING, true);
        commit(SET_NOT_FOUND, false);

        const { palavraChave, modulo } = await dispatch('makeVariables');
        const uf = await rootGetters['user/uf'];
        let query = await env.apolloRevista.query({
          query: NOTICIA_SEARCH_ES,
          variables: {
            uf,
            tags: state.tagsNome,
            palavraChave,
            modulo,
            canalFav: [env.revista.canal],
            ufFav: getUF(uf, 'sigla', 'id'),
            orderBy: ['data_atualizacao:desc'],
          },
          fetchPolicy: 'no-cache',
        });

        const { noticias } = query.data;

        let noticiasArray = [];
        if (Array.isArray(noticias)) {
          noticiasArray = noticias;
        } else if (noticias && Array.isArray(noticias.data)) {
          noticiasArray = noticias.data;
        } else if (noticias && noticias.data) {
          noticiasArray = [noticias.data];
        } else if (noticias) {
          noticiasArray = [noticias];
        }

        if (noticiasArray.length === 0) {
          commit(SET_NOT_FOUND, true);
        } else {
          noticiasArray = noticiasArray.map(noticia => {
            if (noticia.categoriaSlug) {
              noticia.categoria = noticia.categoriaSlug.categoria;
              noticia.categoriaSlug = noticia.categoriaSlug.slug;
            }
            const [dataPub] = noticia.data.split(' ');
            noticia.data = dataPub;
            return noticia;
          });
        }
        commit(SET_NOTICIAS, noticiasArray);
      } catch (e) {
        console.error(e);
        errorGQLHandler(e);
      } finally {
        commit(SET_FINDING, false);
      }
    },
    async resolveCategoria(_, { categoriaSlug, categoriaId }) {
      if (categoriaSlug) return categoriaSlug;

      let {
        data: { categorias },
      } = await env.apolloRevista.query({
        query: CATEGORIAS,
        variables: {
          id: categoriaId,
          modulo: env.revista.modulo,
        },
      });
      const [data] = categorias.data;
      return data;
    },
    async makeVariables({ state, rootGetters }) {
      const {
        informeComercial,
        palavraChave,
        seLiga,
        vigencia,
        periodoDePublicacao,
        prazoDeLeitura,
        tags,
        confirmacaoLeitura,
        categoriaId,
        uf,
        regional,
      } = state;

      const notExistsTagsInKeyWord = !includes(palavraChave, '#');

      const userUf = await rootGetters['user/uf'];

      const [vigenciaInicio, vigenciaFim] = vigencia || [];
      const [dataPublicacaoInicio, dataPublicacaoFim] = periodoDePublicacao || [];
      const [prazoLeituraInicio, prazoLeituraFim] = prazoDeLeitura || [];

      let variables = {
        modulo: env.revista.modulo,
        ativo: '1',
        canal: env.revista.canal,
        uf: [userUf],
        canalFav: [env.revista.canal],
        ufFav: getUF(userUf, 'sigla', 'id'),
      };

      if (tags.length > 0) {
        variables = { tags, ...variables };
      } else {
        variables = { tags: [], ...variables };
      }

      if (informeComercial) {
        variables = { informeComercial, ...variables };
      } else {
        variables = { informeComercial: 0, ...variables };
      }

      if (confirmacaoLeitura) {
        variables = { confirmacaoLeitura, ...variables };
      }

      if (palavraChave && notExistsTagsInKeyWord) {
        variables = { palavraChave, ...variables };
      }

      if (seLiga) {
        variables = { seLiga, ...variables };
      } else {
        variables = { seLiga: 0, ...variables };
      }

      if (categoriaId.length > 0) {
        variables = { categoriaId, ...variables };
      } else {
        variables = { categoriaId: [], ...variables };
      }

      if (vigenciaInicio) {
        variables = { vigenciaInicio: anyDateFormat(vigenciaInicio), ...variables };
      }

      if (vigenciaFim) {
        variables = { vigenciaFim: anyDateFormat(vigenciaFim), ...variables };
      }

      if (dataPublicacaoInicio) {
        variables = { dataPublicacaoInicio: anyDateFormat(dataPublicacaoInicio), ...variables };
      }

      if (dataPublicacaoFim) {
        variables = { dataPublicacaoFim: anyDateFormat(dataPublicacaoFim), ...variables };
      }

      if (prazoLeituraInicio) {
        variables = { prazoLeituraInicio: anyDateFormat(prazoLeituraInicio), ...variables };
      }

      if (prazoLeituraFim) {
        variables = { prazoLeituraFim: anyDateFormat(prazoLeituraFim), ...variables };
      }

      if (rootGetters['home/canal']) {
        variables = { canal: rootGetters['home/canal'], ...variables };
      }

      return variables;
    },
  },
};
